"use strict";

var _interopRequireDefault = require("/www/wwwroot/check/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/www/wwwroot/check/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _defineProperty2 = _interopRequireDefault(require("/www/wwwroot/check/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
var _user = require("@/api/user");
var _org = require("@/api/org");
var _role = require("@/api/role");
var _utils = require("@/utils");
var _permission = _interopRequireDefault(require("@/utils/permission"));
var _file = require("@/api/file");
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _vueTreeselect = _interopRequireDefault(require("@riophae/vue-treeselect"));
require("@riophae/vue-treeselect/dist/vue-treeselect.css");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } // secondary package based on el-pagination
var defaultUser = {
  id: "",
  name: "",
  username: "",
  dept: null,
  avatar: "/media/default/avatar.png"
};
var _default = exports.default = {
  components: {
    Pagination: _Pagination.default,
    Treeselect: _vueTreeselect.default
  },
  data: function data() {
    return {
      user: defaultUser,
      upHeaders: (0, _file.upHeaders)(),
      upUrl: (0, _file.upUrl)(),
      userList: {
        count: 0
      },
      roles: [],
      listLoading: true,
      listQuery: {
        page: 1,
        page_size: 20
      },
      enabledOptions: [{
        key: "true",
        display_name: "激活"
      }, {
        key: "false",
        display_name: "禁用"
      }],
      dialogVisible: false,
      dialogType: "new",
      rule1: {
        name: [{
          required: true,
          message: "请输入姓名",
          trigger: "blur"
        }],
        username: [{
          required: true,
          message: "请输入账号",
          trigger: "change"
        }]
        // password: [
        //   { required: true, message: '请输入密码', trigger: 'change' }
        // ],
      },
      filterOrgText: "",
      treeLoding: false,
      orgData: []
    };
  },
  computed: {},
  watch: {
    filterOrgText: function filterOrgText(val) {
      this.$refs.tree.filter(val);
    }
  },
  created: function created() {
    this.getList();
    this.getOrgAll();
    this.getRoleAll();
  },
  methods: {
    checkPermission: _permission.default,
    handleAvatarSuccess: function handleAvatarSuccess(res, file) {
      this.user.avatar = res.data.path;
    },
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      var isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isLt2M;
    },
    filterUser: function filterUser(value, row) {
      // console.log(value, row,'数据')
      return row.roles_name == value;
    },
    filterNode: function filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    handleOrgClick: function handleOrgClick(obj, node, vue) {
      this.listQuery.page = 1;
      this.listQuery.dept = obj.id;
      this.getList();
    },
    getList: function getList() {
      var _this = this;
      this.listLoading = true;
      (0, _user.getUserList)(this.listQuery).then(function (response) {
        if (response.data) {
          _this.userList = response.data;
        }
        _this.listLoading = false;
      });
    },
    getOrgAll: function getOrgAll() {
      var _this2 = this;
      this.treeLoding = true;
      (0, _org.getOrgAll)().then(function (response) {
        _this2.orgData = (0, _utils.genTree)(response.data);
        _this2.treeLoding = false;
      });
    },
    getRoleAll: function getRoleAll() {
      var _this3 = this;
      (0, _role.getRoleAll)().then(function (response) {
        _this3.roles = (0, _utils.genTree)(response.data);
      });
    },
    resetFilter: function resetFilter() {
      this.listQuery = {
        page: 1,
        page_size: 20
      };
      this.getList();
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleAddUser: function handleAddUser() {
      var _this4 = this;
      this.user = Object.assign({}, defaultUser);
      this.dialogType = "new";
      this.dialogVisible = true;
      this.$nextTick(function () {
        _this4.$refs["Form"].clearValidate();
      });
    },
    handleEdit: function handleEdit(scope) {
      var _this5 = this;
      // console.log(scope.row, "编辑");
      var arr = _objectSpread({}, scope.row);
      this.$delete(arr, 'phone');
      this.user = Object.assign({}, arr); // copy obj
      this.dialogType = "edit";
      this.dialogVisible = true;
      this.$nextTick(function () {
        _this5.$refs["Form"].clearValidate();
      });
    },
    handleDelete: function handleDelete(scope) {
      var _this6 = this;
      this.$confirm("确认删除?", "警告", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "error"
      }).then( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0, _user.deleteUser)(scope.row.id);
            case 2:
              _this6.userList.splice(scope.row.index, 1);
              _this6.$message({
                type: "success",
                message: "成功删除!"
              });
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))).catch(function (err) {
        console.error(err);
      });
    },
    // 确认新增或编辑
    confirm: function () {
      var _confirm = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(form) {
        var _this7 = this;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.$refs[form].validate(function (valid) {
                if (valid) {
                  var isEdit = _this7.dialogType === "edit";
                  if (isEdit) {
                    (0, _user.updateUser)(_this7.user.id, _this7.user).then(function (res) {
                      _this7.getList();
                      _this7.dialogVisible = false;
                      _this7.$message({
                        message: "编辑成功",
                        type: "success"
                      });
                    });
                  } else {
                    (0, _user.createUser)(_this7.user).then(function (res) {
                      _this7.getList();
                      _this7.dialogVisible = false;
                      _this7.$message({
                        message: "新增成功",
                        type: "success"
                      });
                    });
                  }
                } else {
                  return false;
                }
              });
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function confirm(_x) {
        return _confirm.apply(this, arguments);
      }
      return confirm;
    }()
  }
};